import { Modal } from 'react-bootstrap';
import CollapsibleCard from '../common/UI/CollapsibleCard';

interface SQLStep {
  label: string;
  code: string;
  result?: string;
}

interface SQLSection {
  sectionIndex: number;
  intermediate: SQLStep[];
  final: SQLStep[];
}

interface SQLSideBarModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  sqlSections: SQLSection[];
}

const SQLSideBarModal = ({ show, setShow, sqlSections }: SQLSideBarModalProps) => {
  const handleClose = () => setShow(false);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="elysia-modal sql-sidebar-modal"
      contentClassName="right-sidebar-content"
      backdropClassName="custom-backdrop"
      animation={true}
      centered={false}
    >
      <Modal.Header closeButton className="border-bottom-control mb-2 pb-2-5">
        <Modal.Title>SQL Executions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {sqlSections?.length > 0 ? (
          sqlSections.map((section, sectionIdx) => (
            <div key={sectionIdx} className="mb-3">
              {/* Intermediate queries */}
              {section.intermediate.length > 0 && (
                <div className="mb-3">
                  <CollapsibleCard
                    title="Intermediate"
                    content={section.intermediate}
                    defaultOpen={false}
                  />
                </div>
              )}

              {/* Final queries */}
              {section.final.length > 0 && (
                <div className="mb-3">
                  <CollapsibleCard title="Final" content={section.final} defaultOpen={false} />
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="text-center text-muted py-4">No SQL executions yet</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SQLSideBarModal;
